import React from 'react';

import './css/InfoText.css';

export const MonthlyPaymentInfo = () => (
  <>
    <p>Het verzekerd maandbedrag is maximaal gelijk aan 125% van de bruto woonlasten. Onder bruto woonlasten verstaan wij:</p>
    <ul className="monthly-payment-info">
      <li>
        hypotheekrente;
      </li>
      <li>
        hypotheekaflossing;
      </li>
      <li>
        premie overlijdensrisicoverzekering;
      </li>
      <li>
        premie inboedel- en opstalverzekering;
      </li>
      <li>
        gas, water en licht;
      </li>
      <li>
        servicekosten (VvE)
      </li>
    </ul>
  </>
);
